export const routes = {
    HOME:"/home",
    DASHBOARD:"/",
    LOGIN:"/login",
    REGISTER:"/register", 
    LISTINGS:"/job-listings",
    LISTING_DETAILS:"/:job_title/:company/:id",
    ALL_JOBS:"/all-jobs",
    ADD_JOB:"/add-job",
    PROFILE:"/profile"
}